import { ArrowUpward } from '@mui/icons-material';
import { darken, IconButton, SxProps, Theme } from '@mui/material';

export function BackToTopButton({
  onClick,
  sx,
}: {
  onClick?: () => void;
  sx?: SxProps<Theme> | undefined;
}) {
  const bgColor = '#4A4458';
  const hoverBgColor = darken(bgColor, 0.2);
  return (
    <IconButton
      disableRipple
      sx={{
        backgroundColor: bgColor,
        '&:hover': { backgroundColor: hoverBgColor },
        ...sx,
      }}
      onClick={onClick}
    >
      <ArrowUpward />
    </IconButton>
  );
}
